import { DataBean } from "../DataBean";

export class Entailment extends DataBean{


    public async getEntailmentCatalog():Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getEntailmentCatalog_Number",[null]);
    }
}